import request from '../../axios';

const PatchSeedRequirement = async (
  payload: ISeedRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_weight: payload?.wanted_weight,
    weight_unit: payload.weight_unit?.value,
    only_massage_buyer: payload.only_massage_buyer || false,
    brs_type: payload.srs_type?.type,
    is_change_title: payload?.is_change_title,
    ad_type: payload.ad_type,
    images: payload?.images?.map(item => item),
    image: payload?.image,
    filter: 'requirement',
  };
  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });

  return response.data;
};

export default PatchSeedRequirement;
